import { SVGProps } from 'react'

export const TransferIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" className="css-1lvgmx4" {...props}>
      <circle r="23.5" transform="matrix(1 0 0 -1 61.5 34.5)" fill="url(#spot-light_svg__paint0_linear)"></circle>
      <circle cx="61.5" cy="34.499" r="16.537" fill="#76808F"></circle>
      <path d="M53.04 34.5l8.46-8.46 8.46 8.46-8.46 8.46-8.46-8.46z" fill="#929AA5"></path>
      <circle r="23.5" transform="matrix(1 0 0 -1 34.5 61.5)" fill="#F8D33A"></circle>
      <circle r="16.537" transform="matrix(1 0 0 -1 34.5 61.5)" fill="url(#spot-light_svg__paint1_linear)"></circle>
      <path d="M26.04 61.5l8.46 8.46 8.46-8.46-8.46-8.46-8.46 8.46z" fill="#F0B90B"></path>
      <path
        d="M31 22.5l2.5-2.5 2.5 2.5-2.5 2.5-2.5-2.5zM61 68l4-4 4 4-4 4-4-4zM6 47l2-2 2 2-2 2-2-2zM36 12H12v24l24-24zM60 84h24V60L60 84z"
        fill="#E6E8EA"
      ></path>
      <defs>
        <linearGradient
          id="spot-light_svg__paint0_linear"
          x1="23.5"
          y1="0"
          x2="23.5"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#929AA5"></stop>
          <stop offset="1" stopColor="#76808F"></stop>
        </linearGradient>
        <linearGradient
          id="spot-light_svg__paint1_linear"
          x1="16.537"
          y1="0"
          x2="16.537"
          y2="33.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B"></stop>
          <stop offset="1" stopColor="#F8D33A"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export const BuyWithCashIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" className="css-1lvgmx4" {...props}>
      <path fill="#E6E8EA" d="M12 84h72V42H12z"></path>
      <path d="M26 57h44L48 79 26 57z" fill="url(#deposit-light_svg__paint0_linear)"></path>
      <circle r="22" transform="matrix(1 0 0 -1 48 30)" fill="#F8D33A"></circle>
      <circle r="15.053" transform="matrix(1 0 0 -1 48 30)" fill="url(#deposit-light_svg__paint1_linear)"></circle>
      <path d="M39.895 30L48 38.105 56.105 30 48 21.895 39.895 30z" fill="#F0B90B"></path>
      <path d="M80 30l2-2 2 2-2 2-2-2z" fill="#E6E8EA"></path>
      <path d="M19 49l3-3 3 3-3 3-3-3zM65 75.5l1.5-1.5 1.5 1.5-1.5 1.5-1.5-1.5z" fill="#fff"></path>
      <defs>
        <linearGradient
          id="deposit-light_svg__paint0_linear"
          x1="48"
          y1="57"
          x2="48"
          y2="79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#929AA5"></stop>
          <stop offset="1" stopColor="#76808F"></stop>
        </linearGradient>
        <linearGradient
          id="deposit-light_svg__paint1_linear"
          x1="15.053"
          y1="0"
          x2="15.053"
          y2="30.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B"></stop>
          <stop offset="1" stopColor="#F8D33A"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export const DepositIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" className="css-1lvgmx4" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88 21H8v54h80V21zM14 63h44v6H14v-6zm68 0H71v6h11v-6z"
        fill="#E6E8EA"
      ></path>
      <path d="M63 81.5l2.5-2.5 2.5 2.5-2.5 2.5-2.5-2.5zM14 13l3-3 3 3-3 3-3-3z" fill="#E6E8EA"></path>
      <path fill="url(#fiat-light_svg__paint0_linear)" d="M8 32h80v11H8z"></path>
      <circle r="15" transform="matrix(1 0 0 -1 50 23)" fill="#F8D33A"></circle>
      <circle r="10.862" transform="matrix(1 0 0 -1 50 23)" fill="url(#fiat-light_svg__paint1_linear)"></circle>
      <path d="M44.31 23L50 28.69 55.69 23 50 17.31 44.31 23z" fill="#F0B90B"></path>
      <circle r="10" transform="matrix(1 0 0 -1 70 56)" fill="#F8D33A"></circle>
      <circle r="7.273" transform="matrix(1 0 0 -1 70 56)" fill="url(#fiat-light_svg__paint2_linear)"></circle>
      <path d="M66.364 56L70 59.636 73.636 56 70 52.363 66.364 56z" fill="#F0B90B"></path>
      <circle r="12" transform="matrix(1 0 0 -1 28 76)" fill="#F8D33A"></circle>
      <circle r="8.727" transform="matrix(1 0 0 -1 28 76)" fill="url(#fiat-light_svg__paint3_linear)"></circle>
      <path d="M23.636 76L28 80.364 32.364 76 28 71.636 23.636 76z" fill="#F0B90B"></path>
      <defs>
        <linearGradient
          id="fiat-light_svg__paint0_linear"
          x1="88"
          y1="32"
          x2="8"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#929AA5"></stop>
          <stop offset="1" stopColor="#76808F"></stop>
        </linearGradient>
        <linearGradient
          id="fiat-light_svg__paint1_linear"
          x1="10.862"
          y1="0"
          x2="10.862"
          y2="21.724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B"></stop>
          <stop offset="1" stopColor="#F8D33A"></stop>
        </linearGradient>
        <linearGradient
          id="fiat-light_svg__paint2_linear"
          x1="7.273"
          y1="0"
          x2="7.273"
          y2="14.546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B"></stop>
          <stop offset="1" stopColor="#F8D33A"></stop>
        </linearGradient>
        <linearGradient
          id="fiat-light_svg__paint3_linear"
          x1="8.727"
          y1="0"
          x2="8.727"
          y2="17.454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B"></stop>
          <stop offset="1" stopColor="#F8D33A"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export const SwitchBalanceButton = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" fill="#B7BDB7"></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.555 6.31L1 12l5.555 5.69a7.572 7.572 0 0010.89 0L23 12l-5.555-5.69a7.572 7.572 0 00-10.89 0zM17 12a5 5 0 11-10 0 5 5 0 0110 0z"
        fill="#B7BDB7"
      ></path>
    </svg>
  )
}
